module.exports = __webpack_public_path__ + "static/media/Lens-Radiant Charm.51453698.png";